import React, { useMemo } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const GuageChart = ({ chartData, colorCode, chart, selectedPlantId }) => {
  const adjustColorOpacity = (color, isSelected) => {
    if (isSelected) return color; // Keep normal color for selected plants
    const opacity = 0.2; // Adjust opacity for greyed-out effect
    return Highcharts.color(color).setOpacity(opacity).get();
  };

  // Map through chartData to create the data for the chart
  const data = chartData.map((item, index) => {
    const isSelected = selectedPlantId.includes(item.plant_id);
    const color = isSelected ? colorCode[item.plant_id] : "#918c8c";

    let valueToDisplay;
    if (chart === "performance") {
      valueToDisplay = item.payload?.pr?.current_avg;
    } else if (chart === "utilization") {
      valueToDisplay = item.payload?.cuf?.current_avg; // Assuming 'cuf' for utilization
    }

    return {
      label: item.plant_name, // Using plant_id for label as plant_name is not in data
      value: Math.round((valueToDisplay || 0) * 100) / 100,
      color: color,
    };
  });

  // Calculate the center value based on selectedPlantId and chart type
  let centerPercentage = 0;
  if (selectedPlantId && selectedPlantId.length === 1) {
    const selectedPlantData = chartData.find(
      (item) => item.plant_id === selectedPlantId[0]
    );
    if (selectedPlantData) {
      if (chart === "performance") {
        centerPercentage = selectedPlantData.payload?.pr?.current_avg || 0;
      } else if (chart === "utilization") {
        centerPercentage = selectedPlantData.payload?.cuf?.current_avg || 0;
      }
    }
  } else if (chartData.length > 0) {
    // If multiple plants are selected or no specific plant is selected,
    // calculate an average or define a different logic for the center value.
    // For demonstration, let's average the relevant metric across all plants.
    let totalValue = 0;
    let count = 0;
    chartData.forEach((item) => {
      if (
        chart === "performance" &&
        item.payload?.pr?.current_avg !== undefined
      ) {
        totalValue += item.payload.pr.current_avg;
        count++;
      } else if (
        chart === "utilization" &&
        item.payload?.cuf?.current_avg !== undefined
      ) {
        totalValue += item.payload.cuf.current_avg;
        count++;
      }
    });
    centerPercentage = count > 0 ? totalValue / count : 0;
  }

  const centerValue = `${
    typeof centerPercentage === "number" && !isNaN(centerPercentage)
      ? Math.round(centerPercentage)
      : 0
  }%`;

  const series = [
    {
      name: "Value",
      data: data.map((item) => ({
        name: item.label,
        y: item.value,
        color: item.color,
      })),
    },
  ];

  const options = useMemo(
    () => ({
      chart: {
        type: "pie",
        height: 250,
      },
      title: {
        text: null,
      },
      exporting: {
        enabled: false, // Disable exporting
      },
      tooltip: {
        enabled: true,
      },
      credits: {
        enabled: false,
      },
      legend: {
        align: "center",
        verticalAlign: "bottom",
        layout: "horizontal",
        itemStyle: {
          fontWeight: "bold",
          fontSize: "12px",
        },
      },
      plotOptions: {
        pie: {
          innerSize: "70%",
          dataLabels: {
            enabled: false,
          },
        },
      },
      series: series,
    }),
    [chartData, colorCode, selectedPlantId, series]
  );

  return (
    <div style={{ position: "relative", width: "100%", height: "230px" }}>
      <HighchartsReact highcharts={Highcharts} options={options} />
      {data.length > 0 && (
        <div
          style={{
            position: "absolute",
            top: "55%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            fontSize: "28px",
            fontWeight: "bold",
            color: "#000",
            textAlign: "center",
          }}
        >
          {centerValue}
        </div>
      )}
    </div>
  );
};

export default GuageChart;
